import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';
import Users03Icon from 'src/icons/untitled-ui/duocolor/users-03';
import Upload04Icon from 'src/icons/untitled-ui/duocolor/upload-04';
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import Tool02Icon from 'src/icons/untitled-ui/free/tool-02';
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';

export const teacherSections = (t, tokens, paths, SvgIcon) => {
  return [
    {
      items: [
        {
          title: t(tokens.nav.overview),
          path: paths.dashboard.index,
          icon: (
            <SvgIcon fontSize="small">
              <HomeSmileIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.fuel),
          path: paths.fuels.index,
          icon: (
            <SvgIcon fontSize="small">
              <LocalGasStationOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.orderList),
          path: paths.orders.index,
          icon: (
            <SvgIcon fontSize="small">
              <LocalMallOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.students),
          path: paths.students.index,
          icon: (
            <SvgIcon fontSize="small">
              <Users03Icon />
            </SvgIcon>
          ),
        },
        // {
        //   title: t(tokens.nav.fileManager),
        //   path: paths.assets.index,
        //   icon: (
        //     <SvgIcon fontSize="small">
        //       <Upload04Icon />
        //     </SvgIcon>
        //   ),
        // },
        {
          title: t(tokens.nav.repair),
          path: paths.repairs.index,
          icon: (
            <SvgIcon fontSize="small">
              <Tool02Icon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.payslip),
          path: paths.payslips.index,
          icon: (
            <SvgIcon fontSize="small">
              <AccountBalanceWalletOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.workSchedule),
          path: paths.schedules.work.index,
          icon: (
            <SvgIcon fontSize="small">
              <EventOutlinedIcon />
            </SvgIcon>
          ),
        },
        {
          title: t(tokens.nav.repairRequest),
          path: paths.repairs.requests,
          icon: (
            <SvgIcon fontSize="small">
              <BuildCircleOutlinedIcon />
            </SvgIcon>
          ),
        },
      ],
    },
  ];
};
